<template>
  <div class="calendar-guide text-dark">
    <d-modal v-if="isModal" :show-close="false" @close="setIsModal(false)">
      <div slot="insertComponent">
        <div class="icon__bg-circle" @click="setIsModal(false)">
          <span class="icon-cross2"></span>
        </div>
        <div class="modal-body">
          <div class="modal__left">
            <h4>{{ $t('vue2.calendar_export.create_a_link_on_mobile') }}</h4>
            <ul class="export-calendar__cals">
              <li v-for="integration in integrations" :key="integration.id"
                  :class="{'cal--is-active': theActiveIntegration === integration.id}"
                  @click="theActiveIntegration = integration.id">
                {{ integration.title }}
              </li>
            </ul>
          </div>
          <div class="modal__right">
            <h4 class="marg-2-bottom">{{ $t('vue2.calendar_export.guide_to') }} {{ integrations[theActiveIntegration].title }}</h4>
            <div class='embed-container' v-show="theActiveIntegration === 0">
              <iframe src='https://www.youtube.com/embed/Vkw-bVsvkq4' frameborder='0' allowfullscreen></iframe>
            </div>
            <div class='embed-container' v-show="theActiveIntegration === 1">
              <iframe src='https://www.youtube.com/embed/Idpmc8dcFV0' frameborder='0' allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </d-modal>
    <div class="bg-overlay" v-if="isModal" @click="setIsModal(false)"></div>
  </div>
</template>
<script>
import DModal from '../common/DModal'
import Spinner from '../common/Spinner'

export default {
  components: {DModal, Spinner},
  props: {
    isShowFromProp: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isModal: false,
      theActiveIntegration: 0,
      integrations: [
        {
          id: 0,
          title: 'Apple iPhone',
          youTubeLink: 'https://www.youtube.com/watch?v=Vkw-bVsvkq4'
        },
        {
          id: 1,
          title: 'Android',
          youTubeLink: 'https://www.youtube.com/watch?v=Idpmc8dcFV0'
        }
      ]
    }
  },
  watch: {
    isShowFromProp (val) {
      this.setIsModal(val)
    }
  },
  methods: {
    setIsModal (boolean) {
      this.isModal = boolean
      if (!boolean) {
        this.$emit('close')
      }
    }
  }
}
</script>

<style scoped>
@import '../../assets/css/variables.css';

.icon__bg-circle {
  position: absolute;
  top: 4px;
  right: 18px;
}

.modal-body {
  display: flex;
  border-radius: 4px;
}

.modal__left {
  width: 200px;
}

.modal__left h4 {
  padding: 2rem;
}

.modal__right {
  width: 500px;
  height: 500px;
  background-color: #ffffff;
  padding: 2rem;
  overflow: auto;
}

.export-calendar__cals li {
  border-left: 2px solid transparent;
  padding: 1rem 2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.export-calendar__cals li.cal--is-active {
  background-color: rgba(70, 138, 215, 0.15);
  border-color: var(--blue);
  font-weight: bold;
  color: var(--blue);
}

.export-calendar__cals li:hover {
  background-color: rgba(70, 138, 215, 0.05);
  border-color: rgba(70, 138, 215, 0.5);
}

.modal__right img {
  width: 100%;
  border: 1px solid #CCCCCC;
  border-radius: 4px;
  padding: 4px;
  margin-bottom: 1rem;
}

.integration-img {
  width: 24px;
  height: 24px;
  background-size: cover;
  margin-right: 1rem;
  padding: 4px;
  border-radius: 4px;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe, .embed-container object, .embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// CalendarOnMobileGuides.vue?bd8f8a84